import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: { 
      name:"lmj"
  },
  mutations: { },
  getters: { },
  actions: { }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js